import {
  LOGIN_ACTION_FAILURE,
  LOGIN_ACTION_LOADING,
  LOGIN_ACTION_STATUS_RESET,
  // LOGIN_ACTION_SUCCESS,
  LOGOUT_ACTION_FAILURE,
  LOGOUT_ACTION_LOADING,
  LOGOUT_ACTION_STATUS_RESET,
  LOGOUT_ACTION_SUCCESS,
  SET_PLANT_NAME_AND_ROLE,
} from "./auth.types";
import { Auth_Service } from "./auth.services";
import getErrorMessage from "../../util";
import Cookies from "js-cookie";
import { AES, enc } from "crypto-js";
import { jwtDecode } from "jwt-decode";
import sign from "jwt-encode";

const login_loading_action = () => ({
  type: LOGIN_ACTION_LOADING,
  payload: null,
});

// const login_success_action = (payload) => ({
//   type: LOGIN_ACTION_SUCCESS,
//   payload,
// });

const login_failure_action = (err) => ({
  type: LOGIN_ACTION_FAILURE,
  payload: err,
});

const login_action_status_reset_action = () => ({
  type: LOGIN_ACTION_STATUS_RESET,
  payload: null,
});

export const login_action =
  ({ email, password }) =>
    async (dispatch) => {
      dispatch(login_loading_action());
      // axios.post()
      try {
        // console.log("making a post request for login");
        const login_response = await Auth_Service.loginPost({
          email,
          password,
          username: email,
        });
        // console.log(login_response);
        const data = login_response.data;
        // console.log({ user: typeof (data?.user) });
        if (typeof (data?.user) === "string") {
          const encrypted_user_data = data?.user;
          try {
            const decoded_data = await jwtDecode(encrypted_user_data);
            const expire_in_a_week = new Date(
              new Date().getTime() + 7 * 24 * 60 * 60 * 1000
            );
            const auth_cookies = Cookies.withAttributes({
              expires: expire_in_a_week,
              secure: true,
            });
            const stringified_user_data = JSON.stringify(decoded_data);
            // const encrypted_data = AES.encrypt(stringified_user_data, "qc_scheduler");
            const encrypted_data = sign(stringified_user_data, process.env.REACT_APP_JWT_SECRET_KEY);
            // console.log(AES.encrypt("", "qc_scheduler"));
            // console.log({ coooook: AES.decrypt(Cookies.get("current_user") || "", "qc_scheduler").toString() });
            // auth_cookies.set("token", data.data.auth_token,);
            localStorage.setItem("token", decoded_data?.data?.auth_token);
            auth_cookies.set("current_user", encrypted_data);
            auth_cookies.set("isAuth", true);
            window.location.reload();
            // console.log(login_result);
          } catch (error) {
            console.log({ error });
          }
        }
        else {
          // data.user.selected_plant = "sunpharma_dewas";
          // console.log({ data });
          const expire_in_a_week = new Date(
            new Date().getTime() + 7 * 24 * 60 * 60 * 1000
          );
          const auth_cookies = Cookies.withAttributes({
            expires: expire_in_a_week,
            secure: true,
          });
          const stringified_user_data = JSON.stringify(data);
          const encrypted_data = AES.encrypt(stringified_user_data, "qc_scheduler");
          // console.log(AES.encrypt("", "qc_scheduler"));
          // console.log({ coooook: AES.decrypt(Cookies.get("current_user") || "", "qc_scheduler").toString() });
          // auth_cookies.set("token", data.data.auth_token,);
          localStorage.setItem("token", data?.data?.auth_token);
          auth_cookies.set("current_user", encrypted_data);
          auth_cookies.set("isAuth", true);
          // window.location.reload();
          // dispatch(login_success_action(data));
        }
      } catch (err) {
        console.log("error while logging in : ", err?.response?.data?.error_msg);
        const error_message = getErrorMessage(err?.response?.data?.error_msg);
        if (err?.response?.status === 403) {
          dispatch(
            login_failure_action(
              `Invalid Credentials, Please try again. ${err?.response?.data?.error_msg}`
            )
          );
        } else if (err?.response?.status === 400) {
          dispatch(
            login_failure_action(
              "Too many attempts, Please try again after sometime.",
              error_message
            )
          );
        } else {
          dispatch(login_failure_action(error_message));
        }
      } finally {
        setTimeout(() => {
          dispatch(login_action_status_reset_action());
        }, 1500);
      }
    };

const logout_action_loading = () => ({
  type: LOGOUT_ACTION_LOADING,
  payload: null,
});

const logout_action_failure = () => ({
  type: LOGOUT_ACTION_FAILURE,
  payload: null,
});

const logout_action_success = () => ({
  type: LOGOUT_ACTION_SUCCESS,
  payload: null,
});

const logout_action_status_reset_action = () => ({
  type: LOGOUT_ACTION_STATUS_RESET,
  payload: null,
});

export const logout_dispatch = () => (dispatch) => {
  dispatch(logout_action_loading());
  try {
    // localStorage.clear();
    Cookies.remove("token");
    Cookies.remove("current_user");
    Cookies.remove("isAuth");
    localStorage.removeItem("client_id");
    localStorage.removeItem("token");
    setTimeout(() => {
      dispatch(logout_action_success());
    }, 1000);
  } catch (error) {
    dispatch(logout_action_failure());
  } finally {
    setTimeout(() => {
      dispatch(logout_action_status_reset_action());
    }, 1500);
  }
};

const select_plant_and_role_action = ({ selected_plant, role }) => ({
  type: SET_PLANT_NAME_AND_ROLE,
  payload: { selected_plant, role },
});

export const select_plant_dispatch = (selected_plant, role, state) => (dispatch) => {
  dispatch(select_plant_and_role_action({ selected_plant, role }));
  localStorage.setItem("client_id", selected_plant);
  const expire_in_a_week = new Date(
    new Date().getTime() + 7 * 24 * 60 * 60 * 1000
  );
  const cookie_instance = Cookies.withAttributes({
    expires: expire_in_a_week,
    secure: true,
  });
  // const current_user_cookie_bytes = AES.decrypt(
  //   cookie_instance.get("current_user") || "",
  //   "qc_scheduler"
  // );
  const current_user_cookie_bytes = jwtDecode(
    cookie_instance.get("current_user") || "",
    process.env.REACT_APP_JWT_SECRET_KEY
  );
  const current_user_decrypted_data = JSON.parse(
    current_user_cookie_bytes.toString(enc.Utf8) || "{}"
  );
  // const current_user = JSON.parse(Cookies.get("current_user") || "{}");
  current_user_decrypted_data.user.selected_plant = selected_plant;
  current_user_decrypted_data.user.role = role;
  Cookies.set(
    "current_user",
    // AES.encrypt(JSON.stringify(current_user_decrypted_data), "qc_scheduler"),
    sign(JSON.stringify(current_user_decrypted_data), process.env.REACT_APP_JWT_SECRET_KEY),
    {
      expires: expire_in_a_week,
      secure: true,
    }
  );
};
